import { render, staticRenderFns } from "./ViewDataWarningModal.vue?vue&type=template&id=04f8c8d6&scoped=true&"
import script from "./ViewDataWarningModal.vue?vue&type=script&lang=js&"
export * from "./ViewDataWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDataWarningModal.vue?vue&type=style&index=0&id=04f8c8d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8c8d6",
  null
  
)

export default component.exports